export const FETCH_ALL_CAMPAIGNS_INFO = "FETCH_ALL_CAMPAIGNS_INFO";
export const FETCH_SINGLE_CAMPAIGN_INFO = "FETCH_SINGLE_CAMPAIGN_INFO";
export const FETCH_CAMPAIGN_DEMOGRAPHICS_INFO =
  "FETCH_CAMPAIGN_DEMOGRAPHICS_INFO";
export const FETCH_CAMPAIGN_COUNTRY_INFO = "FETCH_CAMPAIGN_COUNTRY_INFO";
export const CREATE_CAMPAIGN = "CREATE_CAMPAIGN";
export const FETCH_PENDING_CAMPAIGNS = "FETCH_PENDING_CAMPAIGNS";
